"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@emotion/react");

const classes = {
  inputFile: {
    display: 'none'
  },
  containerAgregarFotos: {
    textAlign: 'center',
    marginBottom: 20
  },
  fotoPerfilContainer: {
    width: '100%',
    "@media screen and (min-width: 600px)": {
      width: '50%',
      marginLeft: '25%'
    }
  },
  emptyStateContainer: theme => /*#__PURE__*/(0, _react.css)("text-align:center;margin-bottom:", theme.spacing(2), ";margin-top:", theme.spacing(2), ";height:242px;" + (process.env.NODE_ENV === "production" ? "" : ";label:emptyStateContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRlcy9Gb3JtRm90b1BlcmZpbC9zdHlsZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQnVDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRlcy9Gb3JtRm90b1BlcmZpbC9zdHlsZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuY29uc3QgY2xhc3NlcyA9IHtcbiAgICBpbnB1dEZpbGU6IHtcbiAgICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgIH0sXG4gICAgY29udGFpbmVyQWdyZWdhckZvdG9zOntcbiAgICAgICAgdGV4dEFsaWduOiAnY2VudGVyJyxcbiAgICAgICAgbWFyZ2luQm90dG9tOiAyMCxcbiAgICB9LFxuICAgIGZvdG9QZXJmaWxDb250YWluZXI6e1xuICAgICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgICBcIkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDYwMHB4KVwiOiB7XG4gICAgICAgICAgICB3aWR0aDogJzUwJScsXG4gICAgICAgICAgICBtYXJnaW5MZWZ0OiAnMjUlJyxcbiAgICAgICAgfVxuICAgIH0sXG4gICAgZW1wdHlTdGF0ZUNvbnRhaW5lcjogKHRoZW1lKSA9PiBjc3NgXG4gICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHt0aGVtZS5zcGFjaW5nKDIpfTtcbiAgICAgICAgbWFyZ2luLXRvcDogJHt0aGVtZS5zcGFjaW5nKDIpfTtcbiAgICAgICAgaGVpZ2h0OiAyNDJweDtcbiAgICBgLFxuICAgIGVtcHR5U3RhdGU6IHtcbiAgICAgICAgbWF4SGVpZ2h0OiAyNDJcbiAgICB9LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3NlczsiXX0= */"),
  emptyState: {
    maxHeight: 242
  }
};
var _default = classes;
exports.default = _default;